const BASE_URL = process.env.REACT_APP_BACKEND_URL

const EVENT_URL = `${BASE_URL}events`

export default { EVENT_URL }
